import { pleaseConfirm } from "../utils/common";
var combinedScales = ["Couple", "Family"];
var VARIANTS = {
  ARHI: "annual income"
}; /**
   * validAnnualIncome
   * @param {*} value
   * @param {*} funnel
   * @param {*} scale
   * @param {*} fieldName
   */
var validAnnualIncome = function validAnnualIncome(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var scale = arguments.length > 2 ? arguments[2] : undefined;
  var fieldName = arguments.length > 3 ? arguments[3] : undefined;
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = pleaseConfirm("your ".concat(scale && combinedScales.includes(scale) ? "combined " : "").concat(fieldName || VARIANTS[funnel] || VARIANTS.ARHI));
  }
  return error;
};
export default validAnnualIncome;